export const CUSTOM = "Custom";
export const PREVIOUS_ANSWER = "PreviousAnswer";
export const METADATA = "Metadata";
export const NOW = "Now";
